import {Fragment, useEffect, useState} from "react";
import "./style.css";

import Card from '@mui/material/Card';
import { makeStyles} from "@mui/styles";

import SwitchCard from "./SwitchCard";
import LinkCard from "./LinkCard";
import MessageCard from "./MessageCard";
import ActionCard from "./ActionCard"

import { CardMedia } from "@mui/material";
import SwitchResultCard from "./SwitchResultCard";
import EditorCard from "./EditorCard";
import { cardView, userDatas } from "../../hoc/cache";
import { useReactiveVar } from "@apollo/client";

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 3,
    boxShadow: 'none',
    position: 'relative',
    minWidth: 200,
    minHeight: 320,
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%',
      bottom: 0,
      zIndex: 1,
      //background: 'linear-gradient(180deg, rgba(0,0,0,0), grey)',
    },
  },
  content: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    //width: '100%',
  },
  media:{
    backgroundPosition: 'top',
  }
}));

interface CardProps {
  card: {
    id: string;
    title: string; 
    subtitle: string;
    data: string;
    category: string;
    linkto: string;
    img: string;
  };
  ctype: number;
  width: number;
  height: number;
  onCaseSelect?: any;
}

// https://liflo.io/images/template.png : black
// https://liflo.io/images/flow.png : white
// https://image-us.samsung.com/SamsungUS/home/audio/galaxy-buds/MB-04-JustWhatYouWantV4.jpg
const BaseCard = (props: CardProps) => {
  const { card, onCaseSelect, width, height, ctype } = props;
  //const { width : cWidth, height: cHeight } = useReactiveVar(userDatas);
  const cWidth = props.width;
  const cHeight = props.height;
  
  //const mediaStyles = useCoverCardMediaStyles({ bgPosition: 'top' })
  const classes = useStyles();
  const type = localStorage.getItem('type');
  //console.log( "cardData:"+card.data);

  useEffect(()=>{
  },[]);

  if (card === null || card === undefined) return <p>Error!: Wrong Card ID</p>;
  if( card.data === null || card.data === '') return <Fragment/>;

  const linkTo = (link:string) =>  {
    window.open(link, '_blank', "height=800,width=550");
  }

  const onSwitch = (cardId: any) => {
    onCaseSelect( cardId);
  }

  // flow.png -> white.png
  const srv = cardView().src === 1 ? "" : "https://fg.liflo.io";
  //console.log('card.data:'+card.data)
  const jdata = JSON.parse(card.data);
  let image = card.img;
  let bgcolor = "#00000000";

  if( jdata.actions[0][4] !== undefined ){
    //image = jdata.actions[0][4].src;
    //, transform:"translate("+px+"px,"+py+"px) scale("+scale+")"}}
    bgcolor = jdata.actions[0][4].bgcolor;
  }

  let bgimage = image === "" ? srv+"/images/white.png" : `${image.replace(/fileServer/i, srv)}`;

  return (
    <Card sx={{ borderRadius: 3,
      border:2,
      boxShadow: 'none',
      position: 'relative',
      minWidth: 200,
      minHeight: 320,
      height: cHeight,
      width: cWidth, }} variant="outlined">
      <CardMedia
        component="img"
        image={bgimage}
        sx={{
          bgcolor:bgcolor,
          height:cHeight+'px',
        }}
        alt="liflo"
      />

      { (card.category === "switch" && type !== 'slide') && <SwitchCard card={card} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
      { (card.category === "switch" && type === 'slide') && <SwitchResultCard card={card} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
      { (card.category === "action" && type !== 'slide') && <ActionCard card={card} ctype={ctype} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
      { (card.category === "action" && type === 'slide') && <ActionCard card={card} ctype={1} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
      { card.category === "link" && <LinkCard card={card} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
      { card.category === "message" && <MessageCard card={card} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
      { card.category === "assess" && <EditorCard card={card} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
    </Card>
  );
};

export default BaseCard;

/**
 * 
 */
